module.exports = __webpack_public_path__ + "img/collegues-first.f02b5fe4.png";